export default {
    LOAD_MY_SCHEDULE(state, my_schedule) {
        state.items = my_schedule;
    }
}
